import {
  Pressable,
  StyleProp,
  StyleSheet,
  View,
  ViewProps,
  ViewStyle,
} from "react-native";
import React from "react";
import {
  Divider as UIKDivider,
  DividerProps,
  ListItemProps,
  Text,
  TextProps,
} from "@ui-kitten/components";
import Chevron from "components/Chevron";
import { RenderProp } from "@ui-kitten/components/devsupport";

interface BaseCardProps extends ViewProps {
  title?: RenderProp<TextProps> | React.ReactNode;
  titleProps?: TextProps;
}

const Divider: React.FC<DividerProps> = (props) => (
  <UIKDivider
    {...props}
    style={[
      {
        marginVertical: 15,
        backgroundColor: "rgb(234, 234, 234)",
      },
      props.style,
    ]}
  />
);

const BaseCard: React.FC<BaseCardProps> = ({
  title,
  style,
  children,
  titleProps,
  ...rest
}) => {
  return (
    <View style={[styles.container, style]} {...rest}>
      {title !== undefined && (
        <View>
          <Text category="h6" {...titleProps}>
            {title as string}
          </Text>
        </View>
      )}

      {children}
    </View>
  );
};

interface BaseCardListItemProps extends ListItemProps {
  onPress?: () => void;
  showArrow?: boolean;
  dividerStyle?: StyleProp<ViewStyle>;
}

export const BaseCardListItem: React.FC<BaseCardListItemProps> = ({
  accessoryLeft,
  accessoryRight,
  title,
  description,
  onPress,
  showArrow = true,
  dividerStyle,
  ...rest
}) => {
  if (accessoryRight !== undefined) {
    showArrow = false;
  }

  const Base = (props: any) => {
    if (onPress) {
      return <Pressable {...props}>{props.children}</Pressable>;
    } else {
      return <View {...props}>{props.children}</View>;
    }
  };
  return (
    <View>
      <Divider style={dividerStyle} />
      <Base style={styles.listItemContainer} onPress={onPress} {...rest}>
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            flex: 0.9,
          }}
        >
          {accessoryLeft !== undefined && (
            <View style={{ marginRight: 5 }}>
              {accessoryLeft as React.ReactNode}
            </View>
          )}
          <View style={{ flex: 1 }}>
            {
              (typeof title === "string" ? (
                <Text>{title}</Text>
              ) : typeof title === "function" ? (
                title()
              ) : (
                title
              )) as React.ReactNode
            }
            {description && (
              <Text category="c1" style={{ flexWrap: "wrap" }}>
                {description as string}
              </Text>
            )}
          </View>
        </View>
        <View>
          <View>
            {accessoryRight !== undefined &&
              (accessoryRight as React.ReactNode)}
          </View>
          <View>{showArrow && <Chevron direction="right"></Chevron>}</View>
        </View>
      </Base>
      <View>{rest.children}</View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: "white",
    borderRadius: 10,
    paddingHorizontal: 25,
    paddingVertical: 15,
  },
  listItemContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
});
export default BaseCard;
